import { FlyoutContext, FlyoutFooter } from "@app/shared/Flyouts";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESTextInput } from "@app/shared/qes-standards/forms/TextInput";
import { FC, useContext, useState } from "react"

interface ZipPublishProps {
  onPublish: (comment?: string) => void;
}

export const ZipProjectPublishFlyout: FC<ZipPublishProps> = (props: ZipPublishProps) => {
  const [comment, setComment] = useState("");
  const flyoutContext = useContext(FlyoutContext);

  const handlePublish = () => {
    props.onPublish(comment);
    flyoutContext.handleCloseFlyout();
  }

  return (
    <>
      <div className="col-7">
        <QESTextInput
          descriptiveText="This could help you recognize the time slice later."
          label="Publish Tag"
          maxLength={50}
          onChange={e => setComment(e.target.value)}
          showCounter={true}
          testId="zip-project-publish-flyout__comment-input"
          value={comment}
        />
      </div>

      <FlyoutFooter
        submitButton={
          <QESButton
            qesType="primary"
            qesTestId="zip-project-publish-flyout__publish-button"
            onClick={handlePublish}
          >
            Publish
          </QESButton>
        }
      />
    </>
  )
};
